module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-navbar', {
    attrs: {
      "toggleable": "md",
      "type": _vm.type,
      "variant": "secondary"
    }
  }, [_c('b-nav-toggle', {
    attrs: {
      "target": "nav_collapse"
    }
  }), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.descricao.toUpperCase()))]), _vm._v(" "), _c('header-campanha', {
    attrs: {
      "campanha": _vm.campanha
    }
  }), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "nav_collapse"
    }
  }, [_c('b-navbar-nav'), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-item-dropdown', {
    attrs: {
      "text": _vm.username,
      "left": ""
    }
  }, [_c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.logoff()
      }
    }
  }, [_vm._v("Sair")])], 1), _vm._v(" "), _c('b-nav-item', {
    staticClass: "active",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.logoff()
      }
    }
  }, [_vm._v("SAIR")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37c759db","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBar/NavBar.vue
// module id = 739
// module chunks = 7